/* global google */
import { DirectionsRenderer } from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import Toast from '../../../Toast/Toast';

function MapDirectionsRenderer(props) {
    const [directions, setDirections] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const { places, travelMode } = props;

        const waypoints = places.map((p) => ({
            location: { lat: p.latitude, lng: p.longitude },
            stopover: true,
        }));
        const origin = waypoints.shift().location;
        const destination = waypoints.pop().location;

        const directionsService = new google.maps.DirectionsService();
        directionsService.route(
            {
                origin: origin,
                destination: destination,
                travelMode: travelMode,
                waypoints: waypoints,
            },
            (result, status) => {
                if (status === 'OK') {
                    setDirections(result);
                } else {
                    setError(result);
                }
            }
        );
    }, [props.places]);

    if (error) {
        Toast.error('Não foi possível calcular a rota.');
        return null;
    }
    return directions && <DirectionsRenderer directions={directions} />;
}

export default MapDirectionsRenderer;
